import React from "react";
import { Typography, Grid } from "@mui/material";
import DocumentPreview from "../DocumentPreview";
import useAuth from "../../../../hooks/useAuth";
import { useSelector } from "react-redux";
import { selectCurrentUserData } from "../../../../features/auth/authSlice";
import FileDataTableItemMenu from "../FileDataTable/FileDataTableItemMenu";
import { useGetFileDataByIdQuery } from "../../../../features/fileData/fileDataApiSlice";
import Loading from "../../../../components/spinners/Loading";

const PreviewFileFolderView = ({ file }) => {
  const { isAdmin } = useAuth();
  const userData = useSelector(selectCurrentUserData);
  const {
    data: fileData,
    isLoading,
    isFetching,
  } = useGetFileDataByIdQuery(file.fileDataId);

  if (isLoading || isFetching) {
    return <Loading backdrop={true} />;
  }

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h6">{file.name}</Typography>
        {fileData && (
          <FileDataTableItemMenu
            fileData={fileData}
            userId={userData.id}
            isAdmin={isAdmin}
          />
        )}
        {/* Pass the file ID to the dropdown */}
      </Grid>
      <Grid item display={"flex"} width={"100%"} height={"100%"} xs={12} mt={2}>
        <DocumentPreview
          fileId={file.fileDataId}
          fileName={file.name}
          data={{
            fileData: { _id: file.fileDataId, fileName: file.name }, // Document editor needs .docx in fileName to show file
            action: "CONFIRMATION",
          }}
        />
      </Grid>
    </Grid>
  );
};

export default PreviewFileFolderView;
